(() => {
  const body = document.body;
  const dealClock = window.CheapUndiesDeal;
  const dealNow = () => dealClock?.now() ?? Date.now();
  const initCollectionFilters = collectionFilters => {
    if (!collectionFilters || collectionFilters.dataset.filtersInitialized) return;
    collectionFilters.dataset.filtersInitialized = 'true';
    const lifetime = new AbortController();
    collectionFilters._disposeFilters = () => { lifetime.abort(); filterRequest?.abort(); };
    const filterViewport = window.matchMedia("(max-width: 767px)");
    let filterForm = collectionFilters.querySelector('[data-filter-form]');
    const configureFilterGroups = (form, openIndexes = []) => {
      if (!form) return;
      [...form.querySelectorAll(':scope > details')].forEach((group, index) => {
        group.open = !filterViewport.matches || openIndexes.includes(index);
      });
    };
    collectionFilters.open = !filterViewport.matches;
    configureFilterGroups(filterForm);
    filterViewport.addEventListener("change", event => {
      collectionFilters.open = !event.matches;
      configureFilterGroups(filterForm);
    }, { signal: lifetime.signal });
    let filterRequest;
    let filterRequestVersion = 0;
    const enableAutomaticFilters = () => {
      if (!filterForm) return;
      filterForm.dataset.autoFilters = '';
      filterForm.dataset.hasPrice = String(!!filterForm.querySelector('.collection-filter-range'));
    };
    const filterUrl = () => {
      const url = new URL(filterForm.action, location.origin);
      new FormData(filterForm).forEach((value, name) => {
        if (String(value).trim()) url.searchParams.append(name, value);
      });
      return url;
    };
    const updateFilters = async (url, focusInput, addHistory = true) => {
      filterRequest?.abort();
      filterRequest = new AbortController();
      const version = ++filterRequestVersion;
      const results = document.querySelector('.collection-results');
      const status = results?.querySelector('[data-filter-status]');
      if (status) status.textContent = 'Updating products…';
      if (results) results.setAttribute('aria-busy', 'true');
      try {
        const sectionUrl = new URL(url);
        sectionUrl.searchParams.set('section_id', 'main-collection');
        const response = await fetch(sectionUrl, { signal: filterRequest.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Filter update failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextResults = page.querySelector('.collection-results');
        const nextForm = page.querySelector('[data-filter-form]');
        if (!nextResults || !nextForm || !results || !filterForm) throw new Error('Filter section unavailable');
        if (version !== filterRequestVersion) return;
        const openIndexes = [...filterForm.querySelectorAll(':scope > details')]
          .flatMap((group, index) => group.open ? [index] : []);
        results.replaceWith(nextResults);
        filterForm.replaceWith(nextForm);
        filterForm = nextForm;
        configureFilterGroups(filterForm, openIndexes);
        enableAutomaticFilters();
        const nextCount = page.querySelector('.collection-toolbar p');
        const count = document.querySelector('.collection-toolbar p');
        if (nextCount && count) count.textContent = nextCount.textContent;
        if (addHistory) history.pushState({}, '', url);
        nextResults.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        nextResults.querySelector('[data-filter-status]')?.replaceChildren(document.createTextNode('Products updated.'));
        if (focusInput) {
          const matching = [...filterForm.querySelectorAll('input')].find(input => input.name === focusInput.name && input.value === focusInput.value);
          matching?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (error.name !== 'AbortError') location.assign(url);
      } finally {
        if (version === filterRequestVersion) results?.removeAttribute('aria-busy');
      }
    };
    enableAutomaticFilters();
    collectionFilters.addEventListener('change', event => {
      if (event.target.matches('input[type="checkbox"]')) updateFilters(filterUrl(), event.target);
    });
    collectionFilters.addEventListener('submit', event => {
      event.preventDefault();
      updateFilters(filterUrl());
    });
    document.querySelector('.collection-results')?.parentElement.addEventListener('click', event => {
      const link = event.target.closest('[data-filter-remove]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      updateFilters(link.href);
    });
    window.addEventListener('popstate', () => updateFilters(location.href, null, false), { signal: lifetime.signal });
  };
  initCollectionFilters(document.querySelector('.collection-filters'));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.collection-filters').forEach(initCollectionFilters));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.collection-filters').forEach(filters => filters._disposeFilters?.()));
  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.getElementById('site-navigation');
  const cartButton = document.querySelector('.cart-toggle');
  const drawer = document.getElementById('CartDrawer');
  const drawerClose = drawer?.querySelector('.drawer-close');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  let lastFocus;
  let catchTimeout;
  const clearCatch = () => {
    clearTimeout(catchTimeout);
    drawer?.classList.remove('drawer-celebrate');
    const banner = drawer?.querySelector('[data-drawer-catch]');
    if (banner) banner.hidden = true;
  };
  const tickDrawerDeal = () => {
    const timer = drawer?.querySelector('[data-drawer-deal-ends]');
    const kicker = drawer?.querySelector('.drawer-kicker');
    if (!timer) { if (kicker) kicker.hidden = false; return; }
    const deadline = Date.parse(timer.dataset.drawerDealEnds);
    if (!Number.isFinite(deadline)) { timer.hidden = true; if (kicker) kicker.hidden = false; return; }
    dealClock?.sync(timer.dataset.serverNow);
    delete timer.dataset.serverNow;
    const remaining = Math.max(0, Math.ceil((deadline - dealNow()) / 1000));
    timer.hidden = remaining === 0;
    if (kicker) kicker.hidden = remaining > 0;
    const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
    timer.querySelectorAll('[data-drawer-time]').forEach((tile, index) => { tile.textContent = String(values[index]).padStart(2, '0'); });
    timer.querySelector('[role="timer"]').setAttribute('aria-label', `${values[0]} hours ${values[1]} minutes ${values[2]} seconds`);
    timer.querySelector('[data-drawer-timer-label]').textContent = remaining ? 'Today’s Prices End In' : 'Today’s Price Has Ended';
    const dealCopy = timer.querySelector('[data-drawer-deal-copy]');
    const dealMessage = remaining ? 'Today’s Daily Deal' : 'Deal Has Ended';
    if (dealCopy && dealCopy.textContent !== dealMessage) dealCopy.textContent = dealMessage;
    if (!remaining) {
      clearCatch();
      if (timer.dataset.reconciled !== 'true') {
        timer.dataset.reconciled = 'true';
        reconcileCart();
      }
    }
  };
  const celebrateDeal = item => {
    clearCatch();
    const timer = drawer?.querySelector('[data-drawer-deal-ends]');
    const variantId = String(item?.variant_id || item?.id || '');
    const deadline = Date.parse(timer?.dataset.drawerDealEnds || '');
    if (!timer || !Number.isFinite(deadline) || deadline <= dealNow() || !timer.dataset.drawerDealVariants.split(',').includes(variantId)) return;
    const banner = drawer.querySelector('[data-drawer-catch]');
    if (!banner) return;
    const message = banner.querySelector('small');
    if (message) message.textContent = deadline - dealNow() <= 15 * 60 * 1000 ? 'Just in time. Today’s price ends soon.' : 'Today’s deal is in your drawer. Keep an eye on the clock.';
    banner.hidden = false;
    void banner.offsetWidth;
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) drawer.classList.add('drawer-celebrate');
    catchTimeout = setTimeout(clearCatch, 4200);
  };

  const setMenu = open => {
    if (!menuButton || !menu) return;
    menu.classList.toggle('is-open', open);
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close shopping menu' : 'Open shopping menu');
  };
  menuButton?.addEventListener('click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true'));

  const setDrawer = open => {
    if (!drawer || !backdrop || !cartButton) return;
    if (open) { lastFocus = document.activeElement; tickDrawerDeal(); if (drawer.querySelector('[name="checkout"]')) reconcileCart(); refreshDrawerSchedule(); } else clearCatch();
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    drawer.inert = !open;
    cartButton.setAttribute('aria-expanded', String(open));
    backdrop.hidden = !open;
    body.classList.toggle('drawer-open', open);
    if (open) drawerClose?.focus(); else lastFocus?.focus();
  };
  cartButton?.addEventListener('click', () => setDrawer(true));
  let drawerRefreshVersion = 0;
  const refreshCartDrawer = async () => {
    const refreshVersion = ++drawerRefreshVersion;
    const root = window.Shopify?.routes?.root || '/';
    const cartBody = drawer?.querySelector('[data-cart-drawer-body]');
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(`${root}cart?section_id=cart-drawer-content&_=${Date.now()}`, { cache: 'no-store' }),
      fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error('Drawer refresh failed');
    const markup = new DOMParser().parseFromString(await sectionResponse.text(), 'text/html');
    const updatedBody = markup.querySelector('[data-cart-drawer-body]');
    if (!updatedBody || !cartBody) throw new Error('Drawer unavailable');
    const cart = await cartResponse.json();
    if (refreshVersion !== drawerRefreshVersion) return;
    cartBody.replaceChildren(...updatedBody.childNodes);
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    tickDrawerDeal();
  };
  let drawerSchedulePending = false;
  const refreshDrawerSchedule = async () => {
    if (drawerSchedulePending || document.hidden || !drawer || drawer.querySelector('[data-cart-drawer-body]')?.contains(document.activeElement)) return;
    if ([...drawer.querySelectorAll('[name="updates[]"]')].some(input => input.value !== input.defaultValue)) return;
    drawerSchedulePending = true;
    try { await refreshCartDrawer(); if (drawer.querySelector('[name="checkout"]')) await reconcileCart(); }
    catch (_) { /* Totals still require a successful cart read; retry on the next visible poll. */ }
    finally { drawerSchedulePending = false; }
  };
  setInterval(() => {
    if (drawer?.classList.contains('is-open') || document.querySelector('.cart-page')) refreshDrawerSchedule();
  }, 30000);
  document.addEventListener('cart:updated', async event => {
    const root = window.Shopify?.routes?.root || '/';
    try {
      await refreshCartDrawer();
      if (event.detail?.openDrawer) { setDrawer(true); if (event.detail.confirmedAdd === true) celebrateDeal(event.detail.item); }
    } catch (_) {
      const status = event.target.querySelector?.('[data-card-status]') || event.target.closest?.('[data-product-root]')?.querySelector('[data-product-status]');
      if (status) {
        status.textContent = 'Added to your drawer. ';
        const link = document.createElement('a');
        link.href = `${root}cart`;
        link.textContent = 'View drawer';
        status.append(link);
      }
    }
  });
  let removingDrawerItem = false;
  drawer?.addEventListener('click', async event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove || !drawer.contains(remove)) return;
    event.preventDefault();
    if (removingDrawerItem) return;
    removingDrawerItem = true;
    const status = drawer.querySelector('[data-drawer-action-status]');
    if (status) { status.hidden = false; status.textContent = 'Removing item…'; }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.cartLineKey, quantity: 0 })
      });
      if (!response.ok) throw new Error('Cart update failed');
      await refreshCartDrawer();
      clearCatch();
      if (status) { status.hidden = true; status.textContent = ''; }
    } catch (_) {
      if (status) status.textContent = 'Could not update your drawer. Please try again.';
    } finally {
      removingDrawerItem = false;
    }
  });

  drawerClose?.addEventListener('click', () => setDrawer(false));
  drawer?.addEventListener('click', event => {
    if (event.target.closest('[data-drawer-continue]')) setDrawer(false);
    if (event.target.closest('[data-dismiss-catch]')) clearCatch();
  });
  backdrop?.addEventListener('click', () => setDrawer(false));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menuWasOpen = menu?.classList.contains('is-open');
      const openGroup = document.querySelector('.nav-group[open]');
      setMenu(false);
      if (drawer?.classList.contains('is-open')) setDrawer(false);
      document.querySelectorAll('.nav-group[open]').forEach(group => group.removeAttribute('open'));
      if (openGroup) openGroup.querySelector('summary')?.focus();
      else if (menuWasOpen) menuButton?.focus();
    }
    if (event.key === 'Tab' && drawer?.classList.contains('is-open')) {
      const focusable = [...drawer.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter(node => !node.disabled && node.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.querySelectorAll('.nav-group').forEach(group => group.addEventListener('toggle', () => {
    if (!group.open) return;
    document.querySelectorAll('.nav-group[open]').forEach(other => { if (other !== group) other.removeAttribute('open'); });
  }));

  document.querySelector('[data-sort-select]')?.addEventListener('change', event => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    location.assign(url.toString());
  });

  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);

  const paintRegularProductPrice = (node, variant, retailComparison = false) => {
    const current = Number(variant.price);
    const comparison = Number(variant.compare_at_price);
    const hasComparison = Number.isFinite(comparison) && comparison > current;
    node.classList.toggle('product-price--comparison', hasComparison);
    if (hasComparison) {
      const savings = Math.floor((comparison - current) * 100 / comparison);
      node.innerHTML = `<span class="price-block price-block--current"><small>Our Price</small><strong>${formatMoney(current)}</strong></span><span class="price-block price-block--compare"><small>${retailComparison ? 'Retail' : 'Compare At Price'}</small><s>${formatMoney(comparison)}</s></span><span class="price-savings"><span>You Save</span><strong>${savings}%</strong></span>`;
    } else {
      node.innerHTML = `<span class="price-block"><small>Our Price</small><strong>${formatMoney(current)}</strong></span>`;
    }
  };

  let cartRefreshPending;
  const setCheckoutReady = ready => document.querySelectorAll('[name="checkout"]').forEach(button => {
    button.disabled = !ready;
    button.setAttribute('aria-disabled', String(!ready));
  });
  const reconcileCart = () => {
    if (cartRefreshPending) return cartRefreshPending;
    cartRefreshPending = (async () => {
      const notices = [...document.querySelectorAll('[data-cart-price-notice]')];
      setCheckoutReady(false);
      notices.forEach(notice => { notice.hidden = false; notice.textContent = 'Confirming current drawer totals…'; });
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js?_=${Date.now()}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart refresh failed');
        const currentCart = await response.json();
        if (!Array.isArray(currentCart.items) || !Number.isFinite(currentCart.total_price)) throw new Error('Invalid cart');
        const keys = new Set(currentCart.items.map(item => item.key));
        const rendered = [...document.querySelectorAll('.cart-page [data-cart-line-key], .drawer-line[data-cart-line-key]')];
        if (rendered.some(line => !keys.has(line.dataset.cartLineKey))) throw new Error('Drawer contents changed. Reload to review them.');
        const mainCart = document.querySelector('.cart-page');
        if (mainCart && mainCart.querySelectorAll('[data-cart-line-key]').length !== currentCart.items.length) throw new Error('Drawer contents changed. Reload to review them.');
        let changed = false;
        currentCart.items.forEach(item => {
          if (!Number.isFinite(item.final_line_price) || !Number.isFinite(item.final_price)) throw new Error('Invalid price');
          document.querySelectorAll(`[data-cart-line-key="${CSS.escape(item.key)}"]`).forEach(line => {
            const quantity = line.querySelector('[name="updates[]"]');
            if (quantity && Number(quantity.defaultValue) !== item.quantity) throw new Error('Drawer quantities changed. Reload to review them.');
            [['[data-cart-line-price]', item.final_line_price], ['[data-cart-unit-price]', item.final_price]].forEach(([selector, cents]) => {
              line.querySelectorAll(selector).forEach(node => {
                changed ||= Number(node.dataset.priceCents) !== cents;
                node.dataset.priceCents = cents;
                node.textContent = formatMoney(cents);
              });
            });
          });
        });
        document.querySelectorAll('[data-cart-total]').forEach(total => {
          changed ||= Number(total.dataset.priceCents) !== currentCart.total_price;
          total.dataset.priceCents = currentCart.total_price;
          total.textContent = formatMoney(currentCart.total_price);
        });
        document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = currentCart.item_count; });
        notices.forEach(notice => {
          notice.textContent = changed ? 'Your drawer prices were refreshed from Shopify. Review them before checkout.' : 'Shipping and taxes are calculated at checkout.';
        });
        setCheckoutReady(true);
        return true;
      } catch (error) {
        notices.forEach(notice => {
          notice.textContent = `${error.message.startsWith('Drawer ') ? error.message : 'Current drawer totals could not be confirmed.'} `;
          const retry = document.createElement('button');
          retry.type = 'button'; retry.dataset.cartRefreshRetry = ''; retry.textContent = 'Try Again';
          const reload = document.createElement('a'); reload.href = `${window.Shopify?.routes?.root || '/'}cart`; reload.textContent = 'Reload Drawer';
          notice.append(retry, document.createTextNode(' · '), reload);
        });
        return false;
      } finally { cartRefreshPending = null; }
    })();
    return cartRefreshPending;
  };
  document.addEventListener('click', event => { if (event.target.closest('[data-cart-refresh-retry]')) reconcileCart(); });
  document.querySelector('.cart-page')?.querySelector('form')?.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' && event.submitter.disabled) event.preventDefault();
  });
  if (document.querySelector('.cart-page [name="checkout"]')) {
    reconcileCart();
    setInterval(() => { if (!document.hidden) reconcileCart(); }, 30000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) reconcileCart(); });
  }

  tickDrawerDeal();
  setInterval(tickDrawerDeal, 1000);
  document.addEventListener('visibilitychange', tickDrawerDeal);

  const reconcileDealProduct = async deal => {
    if (deal.dataset.dealRefreshStarted === 'true') return;
    deal.dataset.dealRefreshStarted = 'true';
    const add = deal.querySelector('.product-add');
    const status = deal.querySelector('[data-product-status]');
    const price = deal.querySelector('[data-product-price]');
    const priceUpdate = deal.querySelector('[data-product-price-update]');
    if (add) { add.disabled = true; add.textContent = 'Updating Price & Availability'; }
    if (price) price.textContent = 'Confirming current price…';
    if (priceUpdate) { priceUpdate.hidden = false; priceUpdate.textContent = 'This deal has ended. Confirming the current price…'; }
    if (status) { status.classList.add('deal-expired-note'); status.textContent = 'This deal just ended. Confirming the current price and availability…'; }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}products/${encodeURIComponent(deal.dataset.productHandle)}.js?_=${Date.now()}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product refresh failed');
      const currentProduct = await response.json();
      const selectedId = Number(deal.querySelector('[data-variant-id]')?.value);
      const variant = selectedId ? currentProduct.variants.find(item => item.id === selectedId) : currentProduct.variants[0];
      if (!variant) throw new Error('Variant unavailable');
      deal.dataset.dealReconciled = 'true';
      deal._currentVariants = currentProduct.variants;
      if (price) paintRegularProductPrice(price, variant, true);
      deal._updateVariant?.();
      deal.querySelector('.product-deal-status')?.setAttribute('hidden', '');
      if (priceUpdate) priceUpdate.textContent = 'This deal has ended. Shopify confirmed the current price.';
      if (price && !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        price.animate?.([{ opacity: .25, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 500, easing: 'ease-out' });
      }
      if (status) { status.classList.remove('deal-expired-note'); status.textContent = selectedId ? (variant.available ? 'Current price and availability confirmed.' : 'This selection is currently sold out.') : 'Current price and availability confirmed. Choose your options to add this item.'; }
      await reconcileCart();
    } catch (_) {
      deal.dataset.dealReconciled = 'false';
      if (price) price.textContent = 'Current price unavailable. Reload to try again.';
      if (add) { add.disabled = true; add.textContent = 'Price Update Unavailable'; }
      if (priceUpdate) priceUpdate.textContent = 'This deal has ended. The current price could not be confirmed.';
      if (status) status.textContent = 'We could not confirm the current price. Refresh before trying to add this item.';
      await reconcileCart();
    }
  };

  const reconcileDealCards = deal => {
    deal.querySelectorAll('.product-card').forEach(async card => {
      if (card.dataset.currentPriceConfirmed === 'true' || card.dataset.priceRefreshStarted === 'true') return;
      card.dataset.priceRefreshStarted = 'true';
      const price = card.querySelector('.card-price');
      if (!price) return;
      price.textContent = 'Confirming current price…';
      try {
        if (!card.dataset.productHandle) throw new Error('Missing product');
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${encodeURIComponent(card.dataset.productHandle)}.js?_=${Date.now()}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Price unavailable');
        const product = await response.json();
        const variant = product.variants.find(item => item.id === Number(card.dataset.cardVariantId)) || product.variants.find(item => item.available) || product.variants[0];
        if (!variant) throw new Error('Variant unavailable');
        price.innerHTML = `<span class="price-block"><small>Our Price</small><strong>${formatMoney(variant.price)}</strong></span>`;
        card.dataset.currentPriceConfirmed = 'true';
        card.dispatchEvent(new CustomEvent('card:product-refreshed', { detail: { product } }));
      } catch (_) {
        price.textContent = 'Open product for current price';
      }
    });
  };

  const timerCleanups = new WeakMap();
  const initDealTimers = scope => scope.querySelectorAll('[data-deal-ends]').forEach(deal => {
    if (deal.dataset.dealTimerReady) return;
    deal.dataset.dealTimerReady = 'true';
    const countdown = deal.querySelector('[data-countdown]');
    if (!countdown) return;
    dealClock?.sync(deal.dataset.serverNow);
    const end = Date.parse(deal.dataset.dealEnds);
    const lifetime = new AbortController();
    let timer;
    const cleanup = () => { clearInterval(timer); lifetime.abort(); };
    timerCleanups.set(deal, cleanup);
    const productAlert = deal.hasAttribute('data-deal-product') ? deal.querySelector('[data-product-deal-alert]') : null;
    const alertTitle = productAlert?.querySelector('[data-product-deal-alert-title]');
    const motionButton = productAlert?.querySelector('[data-product-alert-motion]');
    const reducedMotion = productAlert ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    let alertPaused = false;
    motionButton?.addEventListener('click', () => { alertPaused = !alertPaused; render(); });
    const render = () => {
      if (!deal.isConnected) { cleanup(); return false; }
      const remaining = end - dealNow();
      if (!Number.isFinite(end) || remaining <= 0) {
        countdown.textContent = 'Deal Ended';
        countdown.removeAttribute('aria-label');
        deal.classList.add('is-ended');
        deal.classList.remove('deal-final-hour', 'deal-final-15');
        if (productAlert) productAlert.hidden = true;
        const statusLabel = deal.querySelector('.product-deal-status > span:nth-of-type(2), .collection-deal-status > span:nth-of-type(2)');
        if (statusLabel) statusLabel.textContent = 'Status';
        const collectionLabel = deal.querySelector('.collection-deal-status > strong');
        if (collectionLabel) collectionLabel.textContent = 'Deal Has Ended';
        const eventTitle = deal.querySelector('.event-name h1');
        const eventCopy = deal.querySelector('.event-name p');
        if (eventTitle) eventTitle.textContent = 'This Deal Has Ended.';
        if (eventCopy) eventCopy.remove();
        if (deal.hasAttribute('data-deal-product')) {
          reconcileDealProduct(deal);
        } else {
          reconcileDealCards(deal);
          if (deal.dataset.cartReconciled !== 'true') { deal.dataset.cartReconciled = 'true'; reconcileCart(); }
        }
        return false;
      }
      deal.classList.toggle('deal-final-hour', remaining <= 60 * 60 * 1000);
      deal.classList.toggle('deal-final-15', remaining <= 15 * 60 * 1000);
      if (productAlert) {
        const finalMinutes = remaining <= 15 * 60 * 1000;
        productAlert.hidden = remaining > 60 * 60 * 1000;
        productAlert.classList.toggle('is-final', finalMinutes);
        productAlert.classList.toggle('is-paused', alertPaused || reducedMotion.matches || document.hidden);
        const alertMessage = finalMinutes ? 'Final 15 Minutes. Make Your Move.' : 'Less Than An Hour. Don’t Play Hard To Get.';
        if (alertTitle && alertTitle.textContent !== alertMessage) alertTitle.textContent = alertMessage;
        if (motionButton) {
          motionButton.hidden = reducedMotion.matches;
          const motionText = alertPaused ? 'Play Motion' : 'Pause Motion';
          if (motionButton.textContent !== motionText) motionButton.textContent = motionText;
          motionButton.setAttribute('aria-label', alertPaused ? 'Play deal alert animation' : 'Pause deal alert animation');
        }
      }
      const alertState = remaining <= 15 * 60 * 1000 ? 'Final 15 minutes' : remaining <= 60 * 60 * 1000 ? 'Final hour' : '';
      if (alertState && countdown.dataset.alertState !== alertState) {
        countdown.dataset.alertState = alertState;
        countdown.setAttribute('aria-label', `${alertState} of this deal`);
      }
      const wholeSeconds = Math.ceil(remaining / 1000);
      const hours = Math.floor(wholeSeconds / 3600);
      const minutes = Math.floor(wholeSeconds / 60) % 60;
      const seconds = wholeSeconds % 60;
      countdown.textContent = `${String(hours).padStart(2, '0')} : ${String(minutes).padStart(2, '0')} : ${String(seconds).padStart(2, '0')}`;
      return true;
    };
    if (render()) {
      timer = setInterval(() => { if (!render()) cleanup(); }, 1000);
      document.addEventListener('visibilitychange', render, { signal: lifetime.signal });
    }
    const next = Date.parse(deal.dataset.nextDealStarts || '');
    if (Number.isFinite(next)) {
      const untilNext = next - dealNow();
      if (untilNext > 0 && untilNext <= 15 * 60 * 1000) {
        deal.classList.add('is-intermission');
        deal.querySelector('[data-deal-intermission]')?.removeAttribute('hidden');
      }
    }
  });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-deal-ends]').forEach(deal => timerCleanups.get(deal)?.()));
  initDealTimers(document);
  document.addEventListener('shopify:section:load', event => initDealTimers(event.target));

  const setResponsiveProductImage = (image, source, alt) => {
    if (!image || !source) return;
    try {
      const url = new URL(source, location.href);
      if (!url.pathname.startsWith('/cdn/shop/') && url.hostname !== 'cdn.shopify.com') throw new Error('Unrecognized image source');
      const atWidth = width => { const sized = new URL(url); sized.searchParams.set('width', String(width)); return sized.href; };
      image.srcset = [360, 540, 720, 1000, 1400].map(width => `${atWidth(width)} ${width}w`).join(', ');
      image.sizes = '(max-width: 767px) 180px, 50vw';
      image.src = atWidth(720);
    } catch (_) {
      image.removeAttribute('srcset');
      image.src = source;
    }
    image.alt = alt || '';
  };

  const initProduct = productRoot => {
    if (productRoot.dataset.productInitialized) return;
    productRoot.dataset.productInitialized = 'true';
    const lifetime = new AbortController();
    productRoot._dispose = () => lifetime.abort();
  productRoot.querySelectorAll('[data-product-thumb]').forEach(button => button.addEventListener('click', () => {
    const image = productRoot.querySelector('[data-main-product-image]');
    if (image && button.dataset.imageSrc) {
      setResponsiveProductImage(image, button.dataset.imageSrc, button.dataset.imageAlt);
      productRoot.querySelectorAll('[data-product-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }
  }));


    productRoot.addEventListener('pointerdown', () => productRoot.classList.add('using-pointer'));
    document.addEventListener('keydown', () => productRoot.classList.remove('using-pointer'), { signal: lifetime.signal });
    const photoDialog = productRoot.querySelector('[data-product-photo-dialog]');
    const enlargedPhoto = photoDialog?.querySelector('[data-enlarged-product-image]');
    const photoClose = photoDialog?.querySelector('[data-product-photo-close]');
    let photoOpener;
    productRoot.querySelectorAll('[data-photo-zoom]').forEach(button => button.addEventListener('click', () => {
      if (!photoDialog?.showModal || !enlargedPhoto) return;
      const primaryPhoto = productRoot.querySelector('[data-main-product-image]');
      const source = button.dataset.photoSource || primaryPhoto?.currentSrc || primaryPhoto?.src;
      if (!source) return;
      const url = new URL(source, location.href);
      if (url.searchParams.has('width')) url.searchParams.set('width', '1800');
      enlargedPhoto.src = url.href;
      enlargedPhoto.alt = button.dataset.photoAlt || primaryPhoto?.alt || productRoot.querySelector('h1')?.textContent || 'Product photo';
      photoOpener = button;
      photoDialog.showModal();
      photoClose?.focus();
    }));
    photoClose?.addEventListener('click', () => photoDialog.close());
    photoDialog?.addEventListener('click', event => { if (event.target === photoDialog) photoDialog.close(); });
    photoDialog?.addEventListener('close', () => { if (photoOpener?.isConnected) photoOpener.focus(); });
    productRoot.querySelector('.product-size-guide-link')?.addEventListener('click', () => { const guide = productRoot.querySelector('#ProductSizeGuide'); if (guide) guide.open = true; });
    const variantsElement = productRoot.querySelector('[data-product-json]');
    const idInput = productRoot.querySelector('[data-variant-id]');
    const addButton = productRoot.querySelector('.product-add');
    const price = productRoot.querySelector('[data-product-price]');
    const radios = [...productRoot.querySelectorAll('[name^="option-"]')];
    let variants = [];
    try { variants = JSON.parse(variantsElement?.textContent || '[]'); } catch (_) {}
    let returnPrices = {};
    try { returnPrices = JSON.parse(productRoot.querySelector('[data-return-prices]')?.textContent || '{}'); } catch (_) {}
    const returnPriceMarkup = variant => {
      const future = returnPrices[String(variant.id)];
      const validUntil = Date.parse(productRoot.dataset.returnValidUntil || '');
      const futureIsValid = dealNow() < validUntil && future && future.current === variant.price && Number.isInteger(future.return) && future.return > variant.price;
      const retail = Number(variant.compare_at_price);
      const retailIsValid = Number.isInteger(retail) && retail > variant.price;
      const tomorrowMarkup = futureIsValid ? `<span class="price-block deal-return-price" data-return-claim><small>Tomorrow</small><b>${formatMoney(future.return)}</b></span>` : '';
      const retailSavings = retailIsValid ? Math.floor((retail - variant.price) * 100 / retail) : 0;
      const retailMarkup = retailIsValid ? `<span class="price-block deal-retail-price"><small>Retail</small><s>${formatMoney(retail)}</s><span class="deal-retail-saving">${retailSavings}% off retail</span></span>` : '';
      const savings = futureIsValid ? Math.floor((future.return - variant.price) * 100 / future.return) : 0;
      const savingMarkup = futureIsValid ? `<span class="deal-saving-tag" data-return-claim aria-label="Save ${savings} percent versus tomorrow’s price"><span><b>Save</b><small>vs Tomorrow</small></span><strong>${savings}%</strong></span>` : '';
      return tomorrowMarkup + retailMarkup + savingMarkup;
    };
    const returnExpiryTimer = productRoot.dataset.returnValidUntil ? setInterval(() => {
      if (!productRoot.isConnected) { clearInterval(returnExpiryTimer); return; }
      if (!(dealNow() < Date.parse(productRoot.dataset.returnValidUntil || '')) || productRoot.classList.contains('is-ended')) productRoot.querySelectorAll('[data-return-claim]').forEach(node => node.remove());
    }, 1000) : null;
    lifetime.signal.addEventListener('abort', () => clearInterval(returnExpiryTimer), { once: true });
    let adding = false;
    let userSelectedProductOption = false;
    const updateVariant = () => {
      const names = [...new Set(radios.map(input => input.name))];
      const values = names.map(name => productRoot.querySelector(`[name="${name}"]:checked`)?.value);
      const sizeGroup = productRoot.querySelector('fieldset[data-option-name="size"]');
      const selectedSize = sizeGroup?.querySelector('[data-selected-size]');
      const chosenSize = sizeGroup?.querySelector('input:checked');
      if (selectedSize) selectedSize.textContent = chosenSize ? ` · ${chosenSize.dataset.sizeFull || chosenSize.value}` : '';
      const currentVariants = productRoot._currentVariants || variants;
      const variant = radios.length ? currentVariants.find(item => item.options.every((option, index) => option === values[index])) : currentVariants[0];
      radios.forEach(input => {
        const index = Number(input.name.replace('option-', '')) - 1;
        const available = currentVariants.some(item => item.available && item.options[index] === input.value && item.options.slice(0, index).every((option, previous) => values[previous] == null || option === values[previous]));
        input.disabled = !available;
        const stamp = input.closest('label')?.querySelector('.option-sold-stamp');
        if (stamp) stamp.hidden = available;
      });
      if (!variant) {
        idInput.value = '';
        addButton.disabled = true;
        const missing = values.findIndex(value => value == null);
        const visibleGroups = [...productRoot.querySelectorAll('fieldset:not([hidden])')];
        const onlySize = visibleGroups.length === 1 && visibleGroups[0] === sizeGroup;
        const soldOut = !currentVariants.some(item => item.available);
        addButton.textContent = soldOut ? 'Sold Out' : missing >= 0 ? (onlySize ? 'Select A Size' : 'Choose Options') : 'Unavailable';
        if (missing < 0) { price.classList.remove('product-price--comparison'); price.textContent = 'This combination is unavailable.'; }
        return;
      }
      idInput.value = variant.id;
      const expiredUnconfirmed = productRoot.classList.contains('is-ended') && productRoot.dataset.dealReconciled !== 'true';
      addButton.disabled = adding || expiredUnconfirmed || !variant.available;
      addButton.textContent = adding ? 'Adding…' : expiredUnconfirmed ? (productRoot.dataset.dealReconciled === 'false' ? 'Price Update Unavailable' : 'Updating Price & Availability') : variant.available ? 'Add To Drawer' : 'Sold Out';
      if (expiredUnconfirmed) price.textContent = productRoot.dataset.dealReconciled === 'false' ? 'Current price unavailable. Reload to try again.' : 'Confirming current price…';
      else if (productRoot.dataset.dealReconciled === 'true') paintRegularProductPrice(price, variant, true);
      else if (productRoot.hasAttribute('data-deal-product')) price.innerHTML = `<span class="price-block"><small>Today</small><strong>${formatMoney(variant.price)}</strong></span>${returnPriceMarkup(variant)}`;
      else paintRegularProductPrice(price, variant);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      if (variant.featured_image?.src && (userSelectedProductOption || productRoot.dataset.preferSecondImage !== 'true')) {
        const image = productRoot.querySelector('[data-main-product-image]');
        const imageAlt = variant.featured_image.alt || productRoot.querySelector('h1')?.textContent || '';
        setResponsiveProductImage(image, variant.featured_image.src, imageAlt);
        productRoot.querySelectorAll('[data-product-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', 'false'));
      }
    };
    productRoot._updateVariant = updateVariant;
    radios.forEach(input => input.addEventListener('change', () => {
      userSelectedProductOption = true;
      updateVariant();
    }));
    if (radios.length) updateVariant();
    const productForm = productRoot.querySelector('.product-form');
    productForm?.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || addButton.disabled || !idInput.value) return;
      const status = productRoot.querySelector('[data-product-status]');
      const selectedId = Number(idInput.value);
      const displayed = (productRoot._currentVariants || variants).find(item => item.id === selectedId);
      adding = true;
      productRoot.dataset.purchaseBusy = 'true';
      addButton.disabled = true;
      let requested = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const check = await fetch(`${root}products/${encodeURIComponent(productRoot.dataset.productHandle)}.js?_=${Date.now()}`, { cache: 'no-store' });
        if (!check.ok) throw new Error('Could not check availability. Please try again.');
        const fresh = await check.json();
        productRoot._currentVariants = fresh.variants;
        const confirmed = fresh.variants.find(item => item.id === selectedId);
        if (!confirmed?.available) throw new Error('This selection is now sold out. Choose another size.');
        if (confirmed.price !== displayed?.price) throw new Error('The price has changed. Review the updated price before adding again.');
        if (fresh.requires_selling_plan) throw new Error('Choose a purchase plan before adding this product.');
        requested = true;
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selectedId, quantity: Number(productForm.querySelector('[name="quantity"]')?.value || 1) }] }) });
        const result = await response.json();
        if (!response.ok) { requested = false; throw new Error(typeof result.description === 'string' ? result.description : 'Could not add this selection.'); }
        if (status) status.textContent = 'Added to your drawer.';
        productForm.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'product-page', confirmedAdd: true, item: result.items?.[0] || result, openDrawer: true } }));
      } catch (error) {
        if (status) status.textContent = requested ? 'Could not confirm the add. Check your drawer before trying again.' : error.message;
      } finally {
        adding = false;
        delete productRoot.dataset.purchaseBusy;
        updateVariant();
      }
    });
  };
  document.querySelectorAll('[data-product-root]').forEach(initProduct);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-product-root]').forEach(initProduct));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-root]').forEach(root => root._dispose?.()));

  document.querySelectorAll('[data-confirm]').forEach(button => button.addEventListener('click', event => {
    if (!confirm(button.dataset.confirm)) event.preventDefault();
  }));
})();
